import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgSendFill({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 48 48"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d="M41.292 8.166a.714.714 0 0 0-.731-.111L7.714 21.622a.714.714 0 0 0 .014 1.324l9.043 3.511a.714.714 0 0 0 .668-.08l11.997-8.531a.714.714 0 0 1 .91 1.097l-9.998 9.632a.713.713 0 0 0-.218.515v9.615a.714.714 0 0 0 1.33.36l4.522-7.748a.358.358 0 0 1 .482-.132l8.32 4.57a.714.714 0 0 0 1.043-.474L41.538 8.86a.726.726 0 0 0-.247-.694Z" />
        </svg>
    )
}
SvgSendFill.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgSendFill
